export function appendQueryParam(
  url: string,
  paramName: string,
  paramValue: string | null
): string {
  const urlObj = new URL(url);

  if (!paramValue) {
    return urlObj.toString();
  }

  if (urlObj.search) {
    urlObj.searchParams.append(paramName, paramValue);
  } else {
    urlObj.search = `?${paramName}=${paramValue}`;
  }

  return urlObj.toString();
}
